/**
 * 车组车辆列表树
 */

import GroupTree from './GroupTree.vue';

export default GroupTree;